import React from "react";
import { Navigate } from "react-router-dom";

function NotAuthorized() {
  return (
    <div style={{ padding: 24 }}>
      <h2>Not authorized</h2>
      <p>You don’t have permission to view this page.</p>
    </div>
  );
}

/**
 * Wrap routes/pages that require any of the given rights.
 * - If `rights` is omitted or empty, only requires being signed in.
 * - If `redirectTo` is provided, navigates there instead of rendering NotAuthorized.
 */
export default function RequireRights({ user, rights = [], children, redirectTo }) {
  if (!user) {
    // Not logged in (or user not loaded)
    return redirectTo ? <Navigate to={redirectTo} replace /> : <NotAuthorized />;
  }
  if (!Array.isArray(user.AccessRights)) {
    return <NotAuthorized />;
  }
  if (rights.length === 0) {
    return children; // any signed-in user is ok
  }
  const hasAny = rights.some((r) => user.AccessRights.includes(r));
  return hasAny ? children : (redirectTo ? <Navigate to={redirectTo} replace /> : <NotAuthorized />);
}